






















import Vue from "vue";
import CmsIcon from "@/components/shared/CmsIcon.vue";
import { CMS_OPTIONS } from "@/config";
import { numberOrNullValidator } from "@/helpers";

export default Vue.extend({
  name: "CmsSelect",

  components: {
    CmsIcon,
  },

  props: {
    value: { validator: numberOrNullValidator, required: true },
  },

  data() {
    return {
      items: CMS_OPTIONS,
      selected: this.value,
    };
  },

  methods: {
    onSelect(value: number) {
      this.selected = value;
      this.$emit("input", value);
    },
  },
});
